export const CAD_POSTAL_CODE_REG = /^([a-z]\d[a-z])\s?(\d[a-z]\d)$/i;
